import { render, staticRenderFns } from "./ImportSectionToggle.vue?vue&type=template&id=4e97963a"
import script from "./ImportSectionToggle.vue?vue&type=script&lang=js"
export * from "./ImportSectionToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports